exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* Colors */\n/* Borders */\n/* Media */\n/* \n    420px because it will not allow 3 buttons\n    at 30% with 10px margins to be displayed \n    on a single line.\n*/\n/* Common sizes */\n/* z indices */\n.cs-Section {\n  position: relative;\n  width: 100%;\n  max-width: 750px;\n}\n.cs-Section__saving-text {\n  position: fixed;\n  top: 45%;\n  color: #c00;\n  box-shadow: 4px 4px 18px #888;\n  background-color: #fff;\n  padding: 1em 2em;\n  font-size: 2em;\n}\n.cs-Section__popup-text {\n  position: fixed;\n  top: 45%;\n  left: 31%;\n  color: #c00;\n  box-shadow: 4px 4px 18px #888;\n  background-color: #fff;\n  padding: 1em 2em;\n  font-size: 2em;\n  width: 720px;\n}\n.cs-Section__popup-message {\n  font-size: large;\n}\n.cs-Section__title {\n  padding-left: 5px;\n}\n.cs-Section__list {\n  list-style: none;\n  padding: 0;\n}\n.cs-Section__error-message {\n  text-align: center;\n}\n.cs-Section__message__button {\n  margin-left: .75em;\n}\n.cs-Section__message {\n  color: #006;\n}\n.cs-Section__invalid {\n  color: #a00;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/Section/Section.less
// module id = 861
// module chunks = 0